<div class="release-notes-container {{ theme$ | async }}">
  <div class="d-flex justify-content-between align-items-center my-3">
    <div class="d-flex flex-column align-items-start w-100">
      <span class="size-title font-weight-bold"> {{ 'NOTIFICATION.RELEASE_NOTES.WHATS_NEW' | translate }} </span>
    </div>

    <lib-button
      data-testid="release-notes-close-button"
      [size]="'custom'"
      [width]="32"
      [height]="32"
      [fontSize]="18"
      [faIcon]="'far fa-times'"
      [color]="'primary-link'"
      (buttonClicked)="closeReleaseNotes()">
    </lib-button>
  </div>

  <div class="accordion-wrapper">
    <mat-accordion multi="false">
      @for (note of releaseNotes; track note; let first = $first) {
        <mat-expansion-panel [expanded]="first" class="release-note-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="d-flex py-3 flex-column align-items-start w-100">
                <span class="mb-1 font-size-normal font-weight-bold">
                  {{ 'NOTIFICATION.RELEASE_NOTES.RELEASE_NOTES' | translate }}:

                  <a target="_blank" class="accent" [href]="note.knowledgeCenterUrl || notesDefaultUrl" style="text-decoration: underline">
                    Wind {{ note.version }}
                  </a>
                </span>

                <small class="text-muted">
                  {{ note.releaseDateTS | dateTimeFormatPipe : 'dmy' }}
                </small>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="release-note-content">
            <mat-accordion multi="true" class="highlights-accordion">
              @for (item of note.highlights; track item) {
                <mat-expansion-panel class="highlight-panel" #highlightPanel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="d-flex flex-column w-100">
                        @if (item.highlightUrl) {
                          <div>
                            <a
                              [href]="item.highlightUrl"
                              target="_blank"
                              rel="noopener"
                              class="font-size-normal font-weight-bold primary-text black-text"
                              (click)="$event.stopPropagation()">
                              {{ item.title }}
                            </a>
                          </div>
                        } @else {
                          <span class="font-size-normal font-weight-bold">
                            {{ item.title }}
                          </span>
                        }

                        @if (!highlightPanel.expanded && item.description !== 'false') {
                          <div class="mt-2 preview-html-clamp">
                            <small class="text-muted" [innerHTML]="item.description | safeHtml:'html':false"></small>  
                          </div>
                        }
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <div class="highlight-content">
                      @if (item.tags && item.tags.length > 0) {
                        <mat-chip-set class="mb-2">
                          @for (tag of item.tags; track tag) {
                            <mat-chip selected>{{ tag }}</mat-chip>
                          }
                        </mat-chip-set>
                      }

                      @if (item.description !== 'false') {
                        <div class="mb-3 description-preview">
                          <small class="text-muted" [innerHTML]="item.description | safeHtml:'html':false"></small>
                        </div>
                      }

                      @if (item.imageUrl) {
                        <div class="my-3 text-center">
                          @if (item.highlightUrl) {
                            <a [href]="item.highlightUrl" target="_blank" rel="noopener">
                              <img [src]="item.imageUrl" alt="{{ item.title }}" class="highlight-image" />
                            </a>
                          } @else {
                            <img [src]="item.imageUrl" alt="{{ item.title }}" class="highlight-image" />
                          }
                        </div>
                      }
                    </div>
                  </ng-template>
                </mat-expansion-panel>
              }
            </mat-accordion>
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</div>
